export default __webpack_public_path__ + "static/media/car_type_black.f1452d3a.svg";